import {handleResponse, handleError, headerset} from "../apiUtils";
import {Allegato} from "../../components/allegati/allegatiSlice";
import {toast} from "react-toastify";

const baseUrl = (
    previsione_id?: number | null,
    pagamento_id?: number | null,
    tipo_documento_id?: number | null,
    preview?: boolean,
) => {
    let baseUrl = process.env.API_URL + "/api/allegati/allegati_list/";
    if (previsione_id || pagamento_id || tipo_documento_id || preview) {
        baseUrl += "?";
        if (previsione_id) {
            baseUrl += `previsione_id=${previsione_id}&`;
        }
        if (tipo_documento_id) {
            baseUrl += `tipo_documento=${tipo_documento_id}&`;
        }
        if (preview) {
            baseUrl += `preview=${true}&`;
        }
    }
    return baseUrl;
};

export function fetchAllegati(
    previsione_id?: number | null,
    tipo_documento_id?: number,
    preview?: boolean
) {
    return fetch(baseUrl(previsione_id, tipo_documento_id, null, preview), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

export function deleteAllegato(allegatoToDelete: Allegato) {
    const url =
        process.env.API_URL + "/api/allegati/allegato/" + allegatoToDelete.id + "/";
    return fetch(url, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

const uploadBaseUrl = (
    nomeFile: string,
    descrizione?: string,
    tipo_documento?: number | null,
    previsione_id?: number | null,
) => {
    let uploadBaseUrl = process.env.API_URL + "/api/allegati/upload/";
    if (previsione_id) {
        uploadBaseUrl += `previsione/${previsione_id}/${nomeFile}`;
    } else {
        toast.error("Errore: manca il riferimento alla previsione");
        return "";
    }
    if (descrizione) {
        uploadBaseUrl += "?descrizione=" + descrizione;
        tipo_documento && (uploadBaseUrl += "&tipo_documento=" + tipo_documento);
    } else {
        tipo_documento && (uploadBaseUrl += "?tipo_documento=" + tipo_documento);
    }

    return uploadBaseUrl;
};

export function uploadAllegato(
    allegato: Allegato,
    file: File
) {
    return fetch(
        uploadBaseUrl(
            file.name,
            allegato.descrizione,
            allegato.tipo_documento,
            allegato.previsione,
        ),
        {
            method: "PUT", // PUT to upload.
            headers: {
                "content-type": "application/json",
                Authorization: headerset().Authorization,
            },
            body: file,
        }
    )
        .then(handleResponse)
        .catch(handleError);
}


// #######################################################################

const tipiDocumentoUrl =
    process.env.API_URL + "/api/allegati/tipo_documento_list/";

export function fetchTipiDocumento() {
    return fetch(tipiDocumentoUrl, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}
